import "./SecurityAndGovernance.module.css";
import EnterpriseHeader from "@/reusable_sections/Header";
import EnterpriseGradeGovernance from "./sections/EnterpriseGradeGovernance";
import ApprovedOnlyAccess from "./sections/ApprovedOnlyAccess";
import CitationBasedAnswers from "./sections/CitationBasedAnswers";
import RefusalOverGuessing from "./sections/RefusalOverGuessing";
import IsolationAndAuditProtocols from "./sections/IsolationAndAuditProtocols";
import PolicyControls from "./sections/PolicyControls";
import NetworkFooter from "@/reusable_sections/Footer";
export default function SecurityAndGovernancePage() {
  return <div>
      <EnterpriseHeader />
      <EnterpriseGradeGovernance />
      <ApprovedOnlyAccess />
      <CitationBasedAnswers />
      <RefusalOverGuessing />
      <IsolationAndAuditProtocols />
      <PolicyControls />
      <NetworkFooter />
    </div>;
}